import { css } from "../../../component-styles";

export const bear = css`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: #222;
  }
  p,
  li {
    color: #444;
  }
  blockquote {
    color: #444;
  }
  a {
    color: var(--blue);
  }
  .search-input {
    color: #444;
  }
  .brand-footer-powered {
    color: #444;
  }
  .blog-post-date {
    color: #444;
  }
  time,
  .bear-date {
    color: #666;
  }
`;
